import {
  bigint,
  date,
  index,
  numeric,
  pgTable,
  time,
  timestamp,
  uuid,
  varchar,
  pgEnum,
  doublePrecision,
  boolean,
} from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const dump_unit = pgEnum('dump_unit', [
  'TONS',
  'YARDS',
  'METRIC_TONS',
  'KGS',
]);
export const dump_status = pgEnum('dump_status', [
  'PENDING',
  'COMPLETED',
  'CANCELLED',
]);

export const dump_ticket = pgTable(
  'dump_ticket',
  {
    ...defaultFields.fieldsWithTenantId(),
    status: dump_status('status').default('PENDING').notNull(),
    driverId: uuid('driverId'),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    ticketNumber: varchar('ticketNumber', { length: 256 }),
    dumpDate: date('dumpDate'),
    dumpTime: time('dumpTime'),
    dumpLocationId: uuid('dumpLocationId'),
    tonsDumped: doublePrecision('tonsDumped'),
    kilogramsDumped: doublePrecision('kilogramsDumped'),
    metricTonsDumped: doublePrecision('metricTonsDumped'),
    yardsDumped: doublePrecision('yardsDumped'),
    unit: dump_unit('unit').default('TONS').notNull(),
    canonicalPhotoId: uuid('canonicalPhotoId'),
    // You can use { mode: "bigint" } if numbers are exceeding js number limitations
    costPerUnitInCents: bigint('costPerUnitInCents', { mode: 'number' }),
    // You can use { mode: "bigint" } if numbers are exceeding js number limitations
    dumpCostInCents: bigint('dumpCostInCents', { mode: 'number' }),
    materialId: uuid('materialId'),

    // LEED tracking
    /** Whether this dump ticket is for a LEED project */
    isLeed: boolean('isLeed').notNull().default(false),
  },
  (table) => {
    return {
      createdAtTs_idx: index('dump_ticket_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('dump_ticket_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('dump_ticket_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('dump_ticket_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('dump_ticket_versionNumber_idx').on(
        table.versionNumber,
      ),

      canonicalPhotoId_idx: index('dump_ticket_canonicalPhotoId_idx').on(
        table.canonicalPhotoId,
      ),
      dumpLocationId_idx: index('dump_ticket_dumpLocationId_idx').on(
        table.dumpLocationId,
      ),
      driverId_idx: index('dump_ticket_driverId_idx').on(table.driverId),
      materialId_idx: index('dump_ticket_materialId_idx').on(table.materialId),
    };
  },
);

export const dump_ticket_history = pgTable('dump_ticket_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  status: dump_status('status'),
  driverId: uuid('driverId'),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
  ticketNumber: varchar('ticketNumber', { length: 256 }),
  dumpDate: date('dumpDate'),
  dumpTime: time('dumpTime'),
  dumpLocationId: uuid('dumpLocationId'),
  tonsDumped: doublePrecision('tonsDumped'),
  kilogramsDumped: doublePrecision('kilogramsDumped'),
  metricTonsDumped: doublePrecision('metricTonsDumped'),
  yardsDumped: doublePrecision('yardsDumped'),
  unit: dump_unit('unit'),
  canonicalPhotoId: uuid('canonicalPhotoId'),
  // You can use { mode: "bigint" } if numbers are exceeding js number limitations
  costPerUnitInCents: bigint('costPerUnitInCents', { mode: 'number' }),
  // You can use { mode: "bigint" } if numbers are exceeding js number limitations
  dumpCostInCents: bigint('dumpCostInCents', { mode: 'number' }),
  materialId: uuid('materialId'),

  // LEED tracking
  isLeed: boolean('isLeed'),
});
